/**
 * Servicio centralizado para llamadas a la API
 * Configura la URL base y headers comunes
 */
import axios from 'axios';

// Crear instancia de axios con configuración base
const api = axios.create({
  baseURL: process.env.REACT_APP_UrlApi || '',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para manejar errores globalmente
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log de errores en desarrollo
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', error.response?.data || error.message);
    }
    return Promise.reject(error);
  }
);

/**
 * Servicios de la API organizados por módulo
 */
export const apiService = {
  // Notaría
  getNotaria: () => api.get('notaria'),
  
  // Cotizador
  getConfigCotizador: () => api.get('configCotizador'),
  cotizarPublico: (payload) => api.post('cotizador/cotizar',payload),
  
  // Ubicación
  getPaises: () => api.get('paises'),
  getDepartamentos: () => api.get('departamentos'),
  getMunicipios: () => api.get('municipios'),
  
  // Solicitudes
  getTipoSolicitud: () => api.get('tipo_solicitud'),
  crearPQR: (formData) => api.post('pqr', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  
  // Contacto
  enviarContacto: (data) => api.post('MailContact', data),
};

// Exportar instancia de axios para usos personalizados
export default api;
